import { Injectable } from '@angular/core';

/** Holds the current Bearer token so the auth interceptor and
 *  non-HTTP token consumers (URL builders) can share it without
 *  introducing a circular dependency through HttpClient. */
@Injectable({ providedIn: 'root' })
export class AuthTokenStore {
  private token = '';

  set(token: string): void {
    this.token = token ?? '';
  }

  get(): string {
    return this.token;
  }
}
